// Whether a design editor session currently holds unsaved work.
//
// This exists because main.tsx's reloadWhenIdle() calls window.location.reload()
// when a new deploy is detected and the tab goes hidden. A beforeunload handler
// CANNOT prompt for a backgrounded tab, so that path would silently destroy
// unsaved editor work — the one case the "we never interrupt someone mid-edit"
// comment there does not actually cover.
//
// Deliberately a module-level flag rather than store state: main.tsx must be able
// to read it without importing the editor (and pulling Konva into the eager
// bundle, which vite.config's manualChunks comment warns crashes the app).

let dirty = false;

export const setEditorDirty = (v: boolean): void => { dirty = v; };
export const isEditorDirty = (): boolean => dirty;
